import { Model } from 'app/model/backendmodel';
import { AdapterRegistry } from '../../../adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { CopySink } from 'app/model/pipeline/copysink/copysink';
import { FormatWriteSettingsAdapter, formatWriteSettingsAdapts } from './format-write-settings.adapter';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { AvroFormatWriteSettings } from 'app/model/pipeline/copysink/format-write-settings/avro-format-write-settings';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AvroFormatWriteSettings),
    asynchronous: true,
    adapts: {
        recordName: '*',
        recordNamespace: '*',
        ...formatWriteSettingsAdapts
    }
})
export class AvroFormatWriteSettingsAdapter extends FormatWriteSettingsAdapter<
    AvroFormatWriteSettings,
    Model.FormatWriteSettings
> {
    protected override async _toResource(model: AvroFormatWriteSettings): Promise<Model.FormatWriteSettings> {
        const result: Model.AvroFormatWriteSettings = FormatWriteSettingsAdapter.getCommonWriteSettingsProperties(
            Metamodel.modelFor(AvroFormatWriteSettings).name
        );
        FormatWriteSettingsAdapter.toFormatWriteSettingsResource(model, result);
        result.recordName = ValueAdapter.toResource(model, AvroFormatWriteSettings.RECORD_NAME);
        result.recordNamespace = ValueAdapter.toResource(model, AvroFormatWriteSettings.RECORD_NAMESPACE);
        return result;
    }

    protected override async _toModel(
        resource: Model.AvroFormatWriteSettings,
        copySink: CopySink
    ): Promise<AvroFormatWriteSettings> {
        const result = FormatWriteSettingsAdapter.createWriteSettingsWithCommonProperties(
            AvroFormatWriteSettings.MODEL,
            copySink
        ) as AvroFormatWriteSettings;
        FormatWriteSettingsAdapter.toFormatWriteSettingsModel(resource, result);
        ValueAdapter.toModel(result, AvroFormatWriteSettings.RECORD_NAME, resource.recordName);
        ValueAdapter.toModel(result, AvroFormatWriteSettings.RECORD_NAMESPACE, resource.recordNamespace);
        return result;
    }
}
